import React from 'react';
import './summary-charges.css';
import NumberFormat from 'react-number-format';

class SummaryCharges extends React.Component {

    constructor(props) {
        super(props);
        this.charges = this.props.charges;
    }

    render = () => {
        return (
            <div className="rea-summaryCharges">
                <div className="rea-block-row">
                    <div className="rea-block-12 rea-padding-0">
                        <div class="rea-sectionHeaders">Summary of Charges</div>
                    </div>
                    <div className="rea-block-12 rea-chargeListContainer">
                        <div className="rea-chargeList rea-block-row">
                            <div className="rea-summaryChargesContainer rea-block-12">
                                {this.charges.totalWithOutInsurance > 0 &&
                                <div className="rea-block-row">
                                    <div className="rea-block-6 rea-colTwo">
                                        <span><strong>Total:</strong></span>
                                    </div>
                                    <div className="rea-block-3 rea-colTwoCharges text-right">
                                        <span>
                                            <NumberFormat value={this.charges.totalWithOutInsurance}
                                                          displayType={'text'}
                                                          thousandSeparator={true} decimalScale='2'
                                                          fixedDecimalScale='true'
                                                          prefix={'$'}/></span>
                                    </div>
                                </div>
                                }
                                {this.charges.insuranceTotal > 0 &&
                                <div className="rea-block-row">
                                    <div className="rea-block-6 rea-colTwo">
                                        <span><strong>LeisureCare Travel Insurance:</strong></span>
                                    </div>
                                    <div className="rea-block-3 rea-colTwoCharges text-right">
                                        <span><NumberFormat value={this.charges.insuranceTotal} displayType={'text'}
                                                            thousandSeparator={true} decimalScale='2'
                                                            fixedDecimalScale='true'
                                                            prefix={'$'}/></span>
                                    </div>
                                </div>
                                }
                                {this.charges.paymentsReceived > 0 &&
                                <div className="rea-block-row">
                                    <div className="rea-block-6 rea-colTwo">
                                        <span><strong>Previous Payments:</strong></span>
                                    </div>
                                    <div className="rea-block-3 rea-colTwoCharges text-right">
                                        <span><NumberFormat value={this.charges.paymentsReceived * -1}
                                                            displayType={'text'}
                                                            thousandSeparator={true} decimalScale='2'
                                                            fixedDecimalScale='true'
                                                            prefix={'$'}/></span>
                                    </div>
                                </div>
                                }
                                {this.charges.pendingPaymentTotal > 0 &&
                                <div className="rea-block-row">
                                    <div className="rea-block-6 rea-colTwo">
                                        <span><strong>In Process Payments:</strong></span>
                                    </div>
                                    <div className="rea-block-3 rea-colTwo text-right rea-inProcessAmount">
                                        <span><NumberFormat value={this.charges.pendingPaymentTotal * -1}
                                                            displayType={'text'}
                                                            thousandSeparator={true} decimalScale='2'
                                                            fixedDecimalScale='true'
                                                            prefix={'$'}/>**</span>
                                    </div>
                                </div>
                                }
                                {this.charges.currentAmount > 0 &&
                                <div className="rea-block-row">
                                    <div className="rea-block-6 rea-colTwo">
                                        <span><strong>Today's Payment:</strong></span>
                                    </div>
                                    <div className="rea-block-3 rea-colTwoCharges text-right">
                                        <span><NumberFormat value={this.charges.currentAmount * -1} displayType={'text'}
                                                            thousandSeparator={true} decimalScale='2'
                                                            fixedDecimalScale='true'
                                                            prefix={'$'}/></span>
                                    </div>
                                </div>
                                }
                                <div className="rea-block-row">
                                    <div className="rea-block-9">
                                        <hr></hr>
                                    </div>
                                </div>
                                <div className="rea-block-row">
                                    <div className="rea-block-6 rea-colTwo">
                                        <span><strong>Remaining Balance:</strong></span>
                                    </div>
                                    <div className="rea-block-3 rea-colTwoCharges text-right">
                                        <span><NumberFormat
                                            value={!this.charges.includeInsurance ? this.charges.remainingBalanceExcludingInsurance.toFixed(2) : this.charges.remainingBalanceIncludingInsurance.toFixed(2)}
                                            displayType={'text'}
                                            thousandSeparator={true} decimalScale='2'
                                            fixedDecimalScale='true'
                                            prefix={'$'}/></span>
                                    </div>
                                </div>
                                {
                                    this.charges.includeInsurance &&
                                    <div className="rea-block-row">
                                        <div className="rea-block-12 rea-mobile-padding-0">
                                            <span>(Includes LeisureCare Travel Insurance)</span>
                                        </div>
                                    </div>
                                }
                                {this.charges.pendingPaymentTotal > 0 &&
                                <div className="rea-block-row rea-padding-0 rea-inProcessDisclaimerText">
                                    **This amount is still being processed.
                                </div>
                                }
                            </div>
                        </div>
                        <div class="rea-payInFull">To prevent cancellation, you must be paid in full by&nbsp;<strong>{
                            new Intl.DateTimeFormat('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit'
                            }).format(new Date(this.charges.finalPaymentDate))
                        }</strong></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SummaryCharges;
